import { cn } from '@/lib/cn';

/**
 * piezas.tsx — las formas que Inicio repite.
 *
 * Nada de aquí sale del archivo: son piezas de esta pantalla, no primitivas. Lo
 * que se comparte con el resto del portal vive en `ui/` y `components/`, y esa
 * separación es lo que impide que en un año haya seis tarjetas distintas.
 *
 * El 2026-09-08, al migrar Novedades, cinco de estas piezas dejaron de ser «de
 * esta pantalla» y subieron a `components/`: `Panel`, `PieDePanel`,
 * `FalloDePanel` y `VacioDePanel` a `components/Panel.tsx`, y `Avatar` a
 * `components/Avatar.tsx`. Las dos pantallas montan los mismos tres paneles
 * laterales, y dejarlas con una copia cada una garantizaba que divergieran.
 */

/* ── Fila pulsable ─────────────────────────────────────────────────────── */

/**
 * Una fila que lleva a otro sitio.
 *
 * Es un `<a href="#…">` y no un botón con `onClick`, y eso importa: el shell
 * navega por `hashchange`, así que un enlace de verdad se puede abrir en una
 * pestaña nueva, copiar y marcar. Un `onClick` con `APP.navigate` haría lo mismo
 * al pulsar y nada de lo demás.
 */
export function FilaEnlace({
  href, icono, children, destacada, className,
}: {
  href: string;
  icono?: string;
  children: React.ReactNode;
  /** Pide algo de quien mira: filete de acento y peso. Para lo informativo, no. */
  destacada?: boolean;
  className?: string;
}) {
  return (
    <a
      href={href}
      className={cn(
        'flex items-center gap-2 rounded-sm border px-3 py-2 text-3 text-ink-2',
        'transition-colors hover:bg-sunken hover:text-brand-ink',
        'focus-visible:focus-anillo',
        'pointer-coarse:min-h-11',
        destacada ? 'border-accent bg-accent/8 font-semibold' : 'border-line',
        className,
      )}
    >
      {icono && <i className={cn('bi', icono, 'shrink-0 text-brand-ink')} aria-hidden="true" />}
      <span className="min-w-0 flex-1">{children}</span>
      <i className="bi bi-chevron-right shrink-0 text-2 text-muted" aria-hidden="true" />
    </a>
  );
}
